/**
 * Pravidlo tagu fotky, JEDNO pro detail fotky (`MediaDetailDrawer`) i panel velkého
 * prohlížeče (`MediaTagsField`): tag je oříznutý a malými písmeny, prázdný ani už
 * přítomný se nepřidá. Hledání knihovny tagy prohledává podřetězcem
 * (`apps/api/src/lib/mediaLibraryQuery.ts`), takže „hoi an" najde i tag „hoi an noc".
 *
 * `null` = nic se nemění (volající neukládá).
 */
export function withMediaTag(tags: readonly string[], input: string): string[] | null {
  const tag = input.trim().toLowerCase();
  if (!tag || tags.includes(tag)) return null;
  return [...tags, tag];
}
